<script lang="ts">
    import * as rt from "@common/AppRT";
    import { Component, mixins } from 'vue-facing-decorator';
    import EvalModelsCommands from '@Evaluation/EvaluationModels/Domain/commands-vue-component';
    import { ValidationError } from "@common/types";

    @Component
    export default class PanelistLandingPage extends mixins(EvalModelsCommands)
    {
        get surveyAccessToken(): string { return this.$route.params.surveyAccessToken; }
        get projectUserAccessToken(): string { return this.$route.params.projectUserAccessToken; }
        
        handler: any = null;
        errorMessage: string = null;

        mounted()
        {
            const $this = this;

            const actions: { [propName: string]: any } =
            {
                SetError: (data: ValidationError) =>
                {
                    $this.errorMessage = data.Error;
                },
            }

            rt.send("EvaluationModels.AccessSurvey", "OpenSurvey",
            {
                SurveyAccessToken: this.surveyAccessToken,
                ProjectUserAccessToken: this.projectUserAccessToken,
            });

            this.handler = rt.subscribeModule("EvaluationModels.AccessSurvey", actions);
        }

        beforeDestroy()
        {
            if (this.handler)
            {
                rt.unsubscribe(this.handler);
            }
        }
    }
</script>

<template>
    <div>
        <div class="d-flex justify-content-center" style="padding-top: 200px;">

            <div class="card" v-if="!errorMessage">
                <div class="card-body">
                    <h5 class="card-title"><i class="fa fa-spinner fa-spin"></i> Loading...</h5>
                </div>
            </div>

            <div class="card" v-if="errorMessage">
                <div class="card-body">
                    <h5 class="card-title">Access denied</h5>
                    <p class="card-text lead">{{errorMessage}}</p><br />
                </div>
            </div>
        </div>
    </div>
</template>
